import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetKanzleilandFolders = ({ enabled }: { enabled: boolean }) => {
  const { tenantId } = useTenant();

  const { data, error, loading, refetch } = useQuery<{
    kanzleilandFolders: object;
  }>(GET_KANZLEILAND_FOLDERS_QUERY, {
    variables: { tenantId },
    fetchPolicy: "network-only",
    skip: !enabled,
  });

  return {
    folders: data?.kanzleilandFolders,
    error,
    loading,
    refetch,
  };
};

export const GET_KANZLEILAND_FOLDERS_QUERY = gql`
  query GetKanzleilandFolders($tenantId: String!) {
    kanzleilandFolders(tenantId: $tenantId)
  }
`;
